package org.zest.insan_360_website.model

import kotlinx.serialization.Serializable

@Serializable
enum class UserRole { STUDENT, ADMIN, SUPER_ADMIN } // student would be client

@Serializable
data class UserProfile(
    val id: String,
    val username: String,
    val email: String,
    val role: UserRole,
    val phone: String,
    val organizationId: String?
)

